import "./modalify.less";
export default function modalify() {
  return function (target) {
    if (typeof target.tag === "undefined") target.tag = "modal--";
    target.tag = "modal--" + target.tag;

    target.modalify = function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return target.create('div', false).then(function (brick) {
        brick.root.classList.add('brick-modalify');
        if (typeof onClose === "function") brick.onClose = onClose;
        if (data === false) return brick;
        return brick.show(data);
      });
    };

    target.prototype.show = function (data) {
      var _this = this;

      return new Promise(function (resolve) {
        _this.render(data).then(function () {
          document.body.appendChild(_this.root);
          window.requestAnimationFrame(function () {
            return _this.root.classList.add('visible');
          });
          setTimeout(function () {
            return resolve(_this);
          }, 400);
        });
      });
    };

    target.prototype.close = function (args) {
      var _this2 = this;

      return new Promise(function (resolve) {
        if (typeof _this2.onClose === 'function') _this2.onClose(args);

        _this2.root.classList.remove('visible');

        setTimeout(function () {
          if (_this2.eventSource === _this2.root) _this2.eventSource = _this2.root.parentNode;
          document.body.removeChild(_this2.root);
          resolve(_this2);
        }, 400);
      });
    };

    target.prototype.shake = function () {
      var _this3 = this;

      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 800;
      return new Promise(function (resolve) {
        _this3.root.firstChild.classList.add('shake');

        setTimeout(function () {
          _this3.root.firstChild.classList.remove('shake');

          resolve(_this3);
        }, timeout);
      });
    };
  };
}